import React, { useCallback } from 'react';
import { DataFilterField, IDataFilterFieldCommonProps } from './DataFilterField';
import { StringComboBox } from '../StringComboBox';
import { PickStringFilterValue } from '@decisions/server/DecisionsFramework/Design/Page/Filters';
// import './ComboFilterField.less'

export interface IPickStringFilterFieldProps extends IDataFilterFieldCommonProps<PickStringFilterValue> {}

// const getClassName = () => classNames('dp-combo-filter-field');

/**
 * Drop Down string pick Personalization / Data Filter Field
 *
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export function PickStringFilterField({ onChange, personalization, validation, value }: IPickStringFilterFieldProps) {
  const onDropDownChange = (chosenValue: string | null) => {
    onValueChange({ Value: chosenValue || '' });
  };

  const onValueChange = useCallback(
    (newValue: { Value: string }) => {
      onChange({ ...value, ...newValue });
    },
    [onChange, value]
  );

  const current = value.Value;

  return (
    <DataFilterField
      value={''}
      fieldText={''}
      onChange={onDropDownChange}
      onFieldChange={noop}
      validation={validation}
      personalization={personalization}
    >
      {() => (
        <StringComboBox
          onValueChange={onDropDownChange}
          options={value.Options}
          currentValue={current}
          className="dp-data-filter-field__input"
          allowFreeText={false}
          hideClear={true}
        />
      )}
    </DataFilterField>
  );
}

function noop() {}
